import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { EthereumBalances, StaticContracts } from './types'
import { getStaticMulticallContracts } from '../../api/v1/statics'

export const fetchStaticContractsAction = createAsyncThunk<StaticContracts>(
  'web3/fetchStaticContractsAction',
  async () => {
    const r = await getStaticMulticallContracts()
    if (!r) {
      throw new Error('Failed to fetch static contracts')
    }
    return r
  }
)
export const updateEthereumBalances = createAction<{
  ethereumBalances: EthereumBalances
}>('web3/updateEthereumBalances')
